export const DRIP_RECIPIENT_STATUS_FILTERS = [
    {
        id: 'inProgressDripSequences',
        name: 'In progress',
    },
    {
        id: 'receivedAllMessagesDripSequences',
        name: 'Received all messages',
    },
    {
        id: 'clickedDripSequences',
        name: 'Clicked any message',
    },
    {
        id: 'unsubscribedDripSequences',
        name: 'Unsubscribed',
    },
    {
        id: 'bouncedDripSequences',
        name: 'Bounced',
    },
] as const;
